<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        <strong>Arcanestats</strong> is not affiliated with
        <a href="https://home.privateerpress.com/">Privateer Press</a>.
        <strong>Warcaster: Neo-Mechanika</strong> is property of
        <a href="https://home.privateerpress.com/">Privateer Press</a>.
      </p>
      <p>
        Written by <a href="https://www.cub3.net">Sergi Pons Freixes</a>. Bugs,
        complaints and suggestions can be sent
        <a href="mailto:arcanestats@cub3.net">here</a>.
      </p>
      <p>
        Did you like it?
        <a href="https://paypal.me/keepitrunning">Help keep it running.</a> Thank you!
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "ThePageFooter"
};
</script>

<style scoped></style>
